<template>
  <Catalogs
    title="Гражданства"
    create-text="Новое"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'CitizenshipAdd'"
    :route-edit="'CitizenshipEdit'"
    :route-view="'CitizenshipView'"
    :route-path="'/citizenships'"
    :can-edit="canEditCitizenshipCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "Citizenships",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: false,
          class: 'citizenship-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: false,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'citizenship-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getCitizenships(data);
    },
    canEditCitizenshipCatalogs() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS_EDIT]);
    }
  }
}
</script>

<style>
.citizenship-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.citizenship-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/Citizenships.vue